import AuthContentProvider from "./AuthContentProvider";

export default AuthContentProvider;
